export interface ValidationMessageMap {
  required: string;
  requiredGroup: string;
  minLength: string;
  maxLength: string;
  invalidCreditCard: string;
  invalidUrl: string;
  invalidEmail: string;
  invalidNumber: string;
  invalidAlpha: string;
  invalidComparison: string;
  invalidFirstCapital: string;
  range: string;
  min: string;
  max: string;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
